import { DraftState, Template } from "../../../../../core/entities/template";
import { formatDate } from "../../../../../core/functions/DateFormatUtility";
import React from "react";

import { ReactComponent as Eye } from "../../../../../resources/icons/eye.svg";
import { ReactComponent as Pen } from "../../../../../resources/icons/pen.svg";
import { RoundedIconButton } from "../../../../components/buttons/RoundedIconButton";

interface Props {
    template: Template;
    onSelect: () => void;
    onEdit: () => void;
    selected: boolean;
}

export function TemplateListItem({
    template,
    onSelect,
    onEdit,
    selected
}: Props) {
    const bg = selected
        ? "bg-primary-identity-Blue text-system-white "
        : "bg-secondary-blue-lightest text-secondary-gray-dark";

    function handleWideClick(e: React.MouseEvent<HTMLLIElement>) {
        onSelect();
    }

    function handleViewClick(e: React.MouseEvent<HTMLLIElement>) {
        e.stopPropagation();
        onSelect();
    }

    function handleEditClick(e: React.MouseEvent<HTMLLIElement>) {
        e.stopPropagation();
        onEdit();
    }

    return (
        <li
            className={"px-20 py-16 text-sx rounded-12  flex " + bg}
            onClick={(e) => handleWideClick(e)}
        >
            <div className={"flex-1"}>
                <p className={"font-semibold"}>{template.title ?? "[Title]"}</p>
                <p>{`${formatDate(template.createdAt) ?? "[CreatedAt]"} af ${template.author ?? "[Author]"}`}</p>
            </div>

            <div className={"space-x-8 flex"}>
                {!selected && (
                    <RoundedIconButton onClick={handleViewClick}>
                        <Eye className={"h-20 w-20"} />
                    </RoundedIconButton>
                )}
                {template.draftState === DraftState.Draft && (
                    <RoundedIconButton onClick={handleEditClick}>
                        <Pen className={"h-16 w-16"} />
                    </RoundedIconButton>
                )}
            </div>
        </li>
    );
}
